// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","navbarLink":"_2v2-0Zp9cGy1P43uEnVXUP","primaryGreen":"#028154","mediumMinWidth":"992px","mediumMaxWidth":"1199px","container":"_2Dakz392uHj4uMv4YjAubc _2v2-0Zp9cGy1P43uEnVXUP","selected":"_2cE8zKK2sxcE7mqe2uPMNr"};


//////////////////
// WEBPACK FOOTER
// ./src/common/home-navbar/menu-item/MenuItem.css
// module id = 374
// module chunks = 0 1 2